import { BodyTextMedium, HeadingText50, ButtonGroup, Button } from '@modernhealth/vital-components';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getUserInformation } from 'src/modules/user/selectors/userSelectors';

import { ReactComponent as Celebration } from '../assets/tada.svg';
import { Page } from '../components/PageLayout';

export const CirclesOnDemandFeedbackConfirmationPage = () => {
    const history = useHistory();
    const user = useSelector(getUserInformation);
    const { t } = useTranslation('circles');
    return (
        <Page.Container>
            <Page.Content
                centered
                alignChildren="center"
                css={{
                    maxWidth: 600,
                }}
            >
                <Celebration height="12rem" width="17rem" />
                <HeadingText50 centered marginBottom={24} marginTop={48}>
                    {t('pages.on_demand_feedback_confirmation.header', { name: user.firstName })}
                </HeadingText50>
                <BodyTextMedium marginBottom={32}>
                    {t('pages.on_demand_feedback_confirmation.message')}
                </BodyTextMedium>
                <ButtonGroup css={{ marginTop: 16 }}>
                    <Button
                        size="large"
                        variant="secondary"
                        onClick={() => {
                            history.replace(`/circles`);
                        }}
                    >
                        {t('pages.on_demand_feedback_confirmation.button.secondary')}
                    </Button>
                    <Button
                        size="large"
                        variant="primary"
                        onClick={() => {
                            history.replace(`/circles/on-demand/`);
                        }}
                    >
                        {t('pages.on_demand_feedback_confirmation.button.primary')}
                    </Button>
                </ButtonGroup>
            </Page.Content>
        </Page.Container>
    );
};
